var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"text-right",attrs:{"cols":"12"}},[_c('px-metabase-dashboard-filtro')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }